import styled from 'styled-components';
import { rem } from 'polished';
import { VehicleDetailsHeadingInformationStyled } from '../VehicleDetailsHeadingInformationStyled';
export const VehicleDetailsHeadingInformationStyledDS = styled(VehicleDetailsHeadingInformationStyled)`
    .delivery {
        background: ${({ theme }) => theme.colors.grey4};
        font-size: ${rem('14px')};
    }

    .information > .titleWithBenefits {
        .title {
            font-size: ${rem('24px')};
            text-transform: uppercase;
        }

        .specs .specs-title {
            font-size: ${rem('16px')};
        }

        .show-characteristics-button {
            width: fit-content;

            .link {
                font-size: ${rem('16px')};
            }

            .icon-wrapper {
                margin-left: ${rem('10px')};
            }

            &:hover {
                .link {
                    border-bottom: none;
                }
            }
        }
    }
`;
